import React from 'react';
import Select from 'react-select';
import styles from './personSelection.module.css'; // Your styles here
import { Icons } from '../../../../code/IconHandler';

export default function PersonSelection({
    persons,
    allPersons,
    disableSelect,
    onAddPerson,
    onRemovePerson,
    onUpdatePosition,
    onUpdateTask,
    onToggleEmail,
    onTogglePhone
}) {
    const availableOptions = allPersons
        .filter(p => !persons.some(ap => ap.contact.id === p.id))
        .map(p => ({ value: p.id, label: `${p.first_name} ${p.family_name}` }));

    return (
        <div className={styles.assignedContacts}>
            {persons.map(assignment => (
                <div key={assignment.contact.id} className={styles.assignedRow}>
                    <div className={styles.contactItem}>
                        <span className={styles.contactName}>
                            {assignment.contact.first_name} {assignment.contact.family_name}
                        </span>

                        {assignment.contact.tel ? (
                            <button
                                type="button"
                                onClick={() => onTogglePhone(assignment.contact.id)}
                                title={assignment.show_phone ? 'Telefon ausblenden' : 'Telefon einblenden'}
                                className={styles.iconButton}
                            >
                                <Icons.Phone color={assignment.show_phone ? '#007bff' : '#ccc'} size={18} />
                            </button>
                        ) : (
                            <div className={styles.iconPlaceholder} />
                        )}

                        {assignment.contact.email ? (
                            <button
                                type="button"
                                onClick={() => onToggleEmail(assignment.contact.id)}
                                title={assignment.show_email ? 'E-Mail ausblenden' : 'E-Mail einblenden'}
                                className={styles.iconButton}
                            >
                                <Icons.Mail color={assignment.show_email ? '#007bff' : '#ccc'} size={18} />
                            </button>
                        ) : (
                            <div className={styles.iconPlaceholder} />
                        )}

                        <input
                            type="text"
                            placeholder="Position z.B. stellv. Vorsitzender"
                            value={assignment.position}
                            onChange={e => onUpdatePosition(assignment.contact.id, e.target.value)}
                            className={styles.positionInput}
                        />
                        <input
                            type="text"
                            placeholder="Aufgabe z.B. Fußballcamps"
                            value={assignment.aufgabe}
                            onChange={e => onUpdateTask(assignment.contact.id, e.target.value)}
                            className={styles.positionInput}
                        />

                        <button
                            type="button"
                            onClick={() => onRemovePerson(assignment.contact.id)}
                            title="Kontakt entfernen"
                            className={styles.iconButton}
                        >
                            <Icons.Delete color="#900" size={18} />
                        </button>
                    </div>

                </div>
            ))}
            {!disableSelect && (
                <Select
                    value={null}
                    onChange={selected => {
                        if (selected) {
                            const person = allPersons.find(p => p.id === selected.value);
                            if (!person) return;
                            onAddPerson(person);
                        }
                    }}
                    options={availableOptions}
                    placeholder="+ Kontakt zuweisen"
                    classNamePrefix="select"
                    isClearable={false}
                    menuPortalTarget={document.body}
                    className={styles.selectInput}
                    styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                        menu: base => ({ ...base, zIndex: 9999 }),
                    }}
                />
            )}
        </div>
    );
}
